import { observer } from 'mobx-react';

import Product from '@/product/entity/Product';

import Collection from '../../entity/Collection';

import styles from './CollectionsList.module.css';
import CollectionsListItem from './CollectionsListItem/CollectionsListItem';

interface CollectionsListProps {
  collections: Collection[];
  productContext?: Nullable<Product>;
  onItemClick?: Nullable<(collection: Collection) => void>;
  withLinks?: boolean;
  onLinkClick?: () => void;
}

function CollectionsList(props: CollectionsListProps) {
  const { collections, productContext = null, onItemClick = null, withLinks = false, onLinkClick } = props;

  return (
    <div className={styles.wishCollections}>
      {collections &&
        collections.map((collection) => (
          <CollectionsListItem
            key={collection.id}
            collection={collection}
            productContext={productContext}
            onItemClick={onItemClick}
            withLinks={withLinks}
            onLinkClick={onLinkClick}
          />
        ))}
    </div>
  );
}

export default observer(CollectionsList);
